import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

const ArtifactHealthIcon = ({ symbol, color }) => {
  return (
    <Glyphicon glyph={symbol} style={{ color, fontSize: '21px', top: 0 }} />
  );
};

ArtifactHealthIcon.propTypes = {
  symbol: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default ArtifactHealthIcon;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthIcon.jsx